import Button from "@/components/Common/Button";
import Modal from "@/components/Common/Modal";
import {inviteWrongAccountModalAtom} from "@/store/jotaiAtoms";
import useTokenStore from "@/store/token";
import useUserStore from "@/store/user";
import {useAtom} from "jotai";
import {useState, type FC} from "react";
import {Trans, useTranslation} from "react-i18next";

const InviteWrongAccountModal: FC = () => {
  const {t} = useTranslation(["multi_account", "common"]);
  const [data, setData] = useAtom(inviteWrongAccountModalAtom);
  const currentEmail = useUserStore(state => state.user.email);
  const [isPending, setIsPending] = useState(false);

  if (!data) {
    return null;
  }

  const close = () => {
    if (!isPending) {
      setData(null);
    }
  };

  const handleLogoutAndAccept = async () => {
    setIsPending(true);
    await useTokenStore.getState().logout();
    // Hard reload to the invite link while logged out so the normal invite flow runs.
    window.location.href = data.inviteUrl;
  };

  return (
    <Modal
      onClose={close}
      isLoading={isPending}
      modalTitle={t("multi_account:invite_wrong_account_title")}
      modalTitleClassName="text-lg"
      backgroundClassName="w-[95vw] sm:w-[32rem] md:w-[32rem] max-h-none rounded-xl"
      className="text-center"
      customBottomRow={
        <div className="border-neutral-white-dark flex flex-col gap-2.5 border-t p-5 sm:flex-row">
          <Button buttonStyle="White" className="h-13 w-full sm:flex-1" isDisabled={isPending} onClick={close}>
            {t("common:cancel")}
          </Button>
          <Button
            buttonStyle="Gradient"
            className="h-13 w-full sm:flex-1"
            isLoading={isPending}
            onClick={handleLogoutAndAccept}>
            {t("multi_account:log_out_and_accept")}
          </Button>
        </div>
      }>
      <span className="text-neutral-black text-sm">
        <Trans
          t={t}
          i18nKey="multi_account:invite_wrong_account_description"
          values={{currentEmail, inviteEmail: data.inviteEmail}}
          components={{email: <span className="font-semibold" />}}
        />
      </span>
    </Modal>
  );
};

export default InviteWrongAccountModal;
